import { useState } from 'react';
import {
  AppBar,
  Box,
  Toolbar,
  Typography,
  Menu,
  MenuItem,
  Button,
} from '@mui/material';
import { Outlet } from 'react-router-dom';

export default function Layout() {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleOpenMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <AppBar position="fixed" sx={{ backgroundColor: '#171717' }}>
        <Toolbar>
          <Typography variant="h6" noWrap component="div" sx={{ flexGrow: 1 }}>
            Carro Commerce API Docs
          </Typography>
          <Box>
            <Button
              color="secondary"
              sx={{ fontWeight: 600 }}
              onClick={handleOpenMenu}
            >
              Support
            </Button>
            <Menu anchorEl={anchorEl} open={open} onClose={handleCloseMenu}>
              <MenuItem
                onClick={() => {
                  window.open(
                    'https://docs.google.com/forms/d/1StZtpTNUMWD7WO2SX9SJ4pPFu_U2YxgOLrvnAQowrgY/edit'
                  );
                  handleCloseMenu();
                }}
              >
                Feature Request
              </MenuItem>
              <MenuItem
                onClick={() => {
                  window.open(
                    'https://docs.google.com/forms/d/1eh43LUd7xISaNc_QQWNZFe0xvCnYSz4f9rhF6i8CjPY/edit'
                  );
                  handleCloseMenu();
                }}
              >
                Bug/Issue Report
              </MenuItem>
              <MenuItem
                onClick={() => {
                  window.open(
                    'https://docs.google.com/forms/d/1j9Q3daBNVFrEKtngD60FywYPiUh1Cpv_2Ak090Zz6-g/edit'
                  );
                  handleCloseMenu();
                }}
              >
                Request More Info
              </MenuItem>
            </Menu>
          </Box>
        </Toolbar>
      </AppBar>
      <Box mt={7}>
        <Outlet />
      </Box>
    </>
  );
}
